<template>
  <Modal v-if="modal" class="Cte__Modal" @close="close">
    <template #header>
      <div class="Cte__Modal__Header">
        <span>{{ title }}</span>
      </div>
    </template>
    <template #body>
      <div class="Cte__Modal__Body">
        <p>{{ text }}</p>

        <div class="Cte__Modal__Actions">
          <BaseButton
            label="Descartar mudanças"
            filled
            color="dark"
            text-color="white"
            @click="cancel"
          />

          <BaseButton
            label="Salvar"
            filled
            color="dark"
            text-color="white"
            @click="save"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>
<script>
import { BaseButton } from '@/components/atoms'
import { Modal } from '@/components/molecules'
export default {
  name: 'CteManagementModal',
  components: {
    BaseButton,
    Modal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: 'Informações foram editadas, tem certeza que quer salvar?',
    },
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {

    //Handlers
    open() {
      this.modal = true
      this.$emit('open')
    },

    close() {
      this.modal = false
      this.$emit('close')
    },

    cancel() {
      this.modal = false
      this.$emit('cancel')
    },

    save() {
      this.modal = false
      this.$emit('save')
    },
  }
}
</script>
<style lang="scss" scoped>
.Cte {
  &__Modal {

    /deep/ .Modal__container {
      width: auto;
      height: auto;
      min-width: 600px;
    }

    &__Header {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      span {
        font-weight: $font-weight-bold;
      }
    }

    &__Body {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
      padding: 1.5rem 1.5rem;
    }

    &__Actions {
      display: flex;
      align-self: flex-end;
      margin-top: 2rem;

      /deep/ .BaseButton  {
        height: 25px;
        margin: 0 10px;

        &__Text {
          text-transform: capitalize;
          margin-left: 0;
        }

      }
    }

  }


}
</style>
